import { Grid, Typography } from '@mui/material';
import { Container } from '@mui/system';
import globals from '../globals';
import EmailField from '../components/login/email_tf';
import RedButton from '../components/redButton';
import { useState } from 'react';


const ForgottenPassPage = () => {
    const [showMessage, setShowMessage] = useState(false);
    const [emailValue, setEmailValue] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');

    const handleEmailChange = (e) => {
        setEmailValue(e.target.value);
        setErrorMessage(''); // Clear error when user types
    };

    const handleSubmit = async () => {
        if (emailValue.trim() === '') {
            return; // Don't submit if email is empty
        }

        setIsLoading(true);
        setErrorMessage('');

        try {
            const response = await fetch(`${globals.apiUrl}/auth/forgot-password`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    email: emailValue.trim()
                })
            });

            if (response.ok) {
                setShowMessage(true);
            } else {
                setErrorMessage('Възникна грешка при изпращане на заявката');
            }
        } catch (error) {
            setErrorMessage('Възникна грешка при свързване със сървъра');
        } finally {
            setIsLoading(false);
        }
    }

    return (
        <Container>
            <Grid item>
                <Typography sx={{ color: globals.colors.darkBlue, fontWeight: 'bold' }}>Моля, въведете имейл адреса, с който е създаден вашият профил.</Typography>
            </Grid>
            <Grid item sx={{ mt: 2 }}>
                <EmailField onChange={handleEmailChange} />

                <RedButton
                    onClick={handleSubmit}
                    sx={{ mx: 5, my: 1 }}
                    text={isLoading ? 'Изпращане...' : 'Изпращане'}
                    disabled={emailValue.trim() === '' || isLoading}
                />
                {showMessage && <Typography sx={{ color: globals.colors.lightGreen, mt: 1 }}>Очаквайте имейл за възстановяване на паролата.</Typography>}
                {errorMessage && <Typography sx={{ color: globals.colors.lightRed, mt: 1 }}>{errorMessage}</Typography>}
            </Grid>
        </Container>
    );
}

export default ForgottenPassPage;